import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE = 'https://lunetteriedurussey.fr';
const DEFAULT_IMAGE = `${BASE}/slide02.jpg`;

/**
 * Met à jour le <title>, les metas de description, og:* et twitter:* de la page courante.
 * @param {string}  title
 * @param {string}  description
 * @param {string}  [image]  - chemin relatif (/banner-montures.jpg) ou URL absolue
 */
export const PageHead = ({ title, description, image }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    const imgUrl = image
      ? (image.startsWith('http') ? image : `${BASE}${image}`)
      : DEFAULT_IMAGE;

    const pageUrl = `${BASE}${pathname}`;

    document.title = title;

    const set = (sel, attr, val) => {
      const el = document.querySelector(sel);
      if (el) el.setAttribute(attr, val);
    };

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', pageUrl);

    // Standard
    set('meta[name="description"]',          'content', description);

    // Open Graph
    set('meta[property="og:title"]',         'content', title);
    set('meta[property="og:description"]',   'content', description);
    set('meta[property="og:url"]',           'content', pageUrl);
    set('meta[property="og:image"]',         'content', imgUrl);
    set('meta[property="og:image:alt"]',     'content', title);

    // Twitter / X
    set('meta[name="twitter:title"]',        'content', title);
    set('meta[name="twitter:description"]',  'content', description);
    set('meta[name="twitter:url"]',          'content', pageUrl);
    set('meta[name="twitter:image"]',        'content', imgUrl);
    set('meta[name="twitter:image:alt"]',    'content', title);
  }, [title, description, image, pathname]);

  return null;
};
